const isMobile =
  /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent) ||
  window.matchMedia("(max-width: 768px)").matches;
let drawerWidth = 150;
if (isMobile) {
  drawerWidth = 0;
}
const changePasswordOrPinPageStyle = (theme) => ({
  content: {
    padding: theme.spacing(3),

    paddingTop: 60,
    paddingBottom: 38,
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: 0,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
  },
});

export default changePasswordOrPinPageStyle;
